module.exports = __webpack_public_path__ + "img/img_32.575a22db.png";